import { render, staticRenderFns } from "./CheckupView.vue?vue&type=template&id=809f541a&lang=pug"
import script from "./CheckupView.vue?vue&type=script&lang=js"
export * from "./CheckupView.vue?vue&type=script&lang=js"
import style0 from "./checkup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports